<template>
  <picker-field :label="computedLabel" :value="value" ref="picker" @open="onSearch">
    <div class="list">
      <div class="weui-cells">
        <div
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          @click="select(item)"
        >
          <div class="weui-cell__bd">
            <p>{{displayValue(item)}}</p>
          </div>
          <div class="weui-cell__ft"></div>
        </div>
      </div>
    </div>
  </picker-field>
</template>

<script>
import PickerField from "@/components/field/PickerField.vue";

export default {
  components: {
    PickerField
  },
  props: {
    label: String,
    value: String,
    isRec: {
      type: Boolean,
      default: true
    },
    // 选择指定供应商/客户的收/付款方式
    limit: String,
    limitId: Number
  },
  computed: {
    computedLabel() {
      var me = this;
      return me.label || (me.isRec ? "收款方式" : "付款方式");
    }
  },
  data() {
    var limit = this.limit, displayField = 'pa_name';
    if (limit == 'customer') {
      displayField = 'cp_paname';
    } else if (limit == 'vendor') {
      displayField = 'vp_paname';
    }
    return {
      items: [],
      displayField
    };
  },
  methods: {
    displayValue(item) {
      return item[this.displayField];
    },
    select(item) {
      var me = this;
      me.$emit("input", me.displayValue(item));
      me.$emit("select", item);
      me.$refs.picker.close();
    },
    onSearch() {
      var me = this, url;
      if (me.limit == 'customer') {
        if (!me.limitId) {
          me.$weui.topTips("请选择客户", 2000);
          return;
        }
        // 客户收款方式
        url = "/api/document/customer/getPaymentsRec?id=" + me.limitId;
      } else if (me.limit == 'vendor') {
        if (!me.limitId) {
          me.$weui.topTips("请选择供应商", 2000);
          return;
        }
        // 供应商收款方式
        url = "/api/document/vendor/getPaymentsPay?id=" + me.limitId;
      } else {
        if (me.isRec) {
          url = "/api/document/paymentsrec/list/enable";
        } else {
          url = "/api/document/paymentspay/list/enable";
        }
      }
      me.$loading({
        url
      }).then(function(res) {
        if (res.success) {
          me.items = res.data;
        } else {
          me.$weui.topTips(res.message, 2000);
        }
      });
    }
  }
};
</script>